import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <path d="M18.0667 19L19 18.0755L12.8667 12L19 5.92453L18.0667 5L11 12L18.0667 19Z" fill="#3C101E" />
      <path d="M12.0667 19L13 18.0755L6.86667 12L13 5.92453L12.0667 5L5 12L12.0667 19Z" fill="#3C101E" />
    </Icons>
  );
}
